import { Visualisation } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { fetchClientAtom } from '@/atoms/queries/client';
import { getVisualisationsForMetric } from '@/utils/configVisualisation';
import { objSnakeToCamel } from '@/utils/queries';
import { filtersAtom } from '../filters/filter';

const rawVisualisationsAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  return {
    queryKey: ['visualisations'],
    queryFn: async () => (await fetch(`/visualisations`)) as Promise<Visualisation[]>,
  };
});

const visualisationsAtom = atom(async get => (await get(rawVisualisationsAtom)).data.map(objSnakeToCamel));

export const visualisationConfigsAtom = atom(async get => {
  const configVisualisation = await get(visualisationsAtom);
  const selectedMetric = get(filtersAtom).metric || '';
  const availableVisualisations = getVisualisationsForMetric(configVisualisation, selectedMetric);
  return availableVisualisations;
});
